
<h2 mat-dialog-title> {{ 'DIALOG_MESSAGE.LABEL1' | translate }} </h2>
<mat-dialog-content>
    <span>
        {{ 'DIALOG_MESSAGE.LABEL2' | translate }} <b>{{data}}</b> {{ 'DIALOG_MESSAGE.LABEL3' | translate }}  
        <a href="https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/Descarga.aspx" target="_blank"> {{ 'DIALOG_MESSAGE.LABEL4' | translate }} </a>
    </span>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="d-flex flex-row justify-content-end w-100">
        <button mat-raised-button color="primary" (click)="close()"> {{ 'DIALOG_MESSAGE.LABEL5' | translate }} </button>
    </div>
</mat-dialog-actions>